import { useEffect, useState } from 'react';
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator, CommandShortcut } from '../ui/command';


import { Link, useNavigate, UseNavigateResult } from '@tanstack/react-router';
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { SearchAvailableSchema } from '@/routes/(pharma)/_layout/sales/-data/models/search';
import getPharmacyID from '@/utils/pharmacy_code';
import { httpClient } from '@/httpClient';
import { AICommandPredictionSchema } from './models';
import intent_url_mapper from '@/utils/intent_mapper';
import { pharmacyClient } from '@/connect';
import { ItemType } from '@/gen/inventory/common_pb';
import { Level, StockPointType } from '@/gen/auth/common_pb';

interface CommandItemwrapperProps {
    id?: string,
    title: string,
    subtitle: string,
    href: string,
    setOpen: (open: boolean) => void,
    navigate: UseNavigateResult<string>
    disabled: boolean
}

function CommandItemWrapper(props: CommandItemwrapperProps) {

    const { id, href, subtitle, title, setOpen, navigate, disabled } = props;
    return <CommandItem asChild value={id} disabled={disabled}
        onSelect={() => {
            setOpen(false)
            if (!disabled) {
                navigate({
                    to: href
                })
            }
        }}
        className='p-0 m-0'>
        <div className='cursor-pointer'>
            <Link className='flex flex-col p-2 rounded-md' onClick={() => {
                setOpen(false)
            }} to={href} disabled={disabled} style={{
                pointerEvents: disabled ? 'none' : 'auto',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1
            }}>
                <p className='text-lg font-semibold'>
                    {title}
                </p>
                <p className='text-sm font-normal text-muted-foreground'>
                    {subtitle}
                </p>
            </Link>
        </div>
    </CommandItem>
}

type InternalCommand = {
    id?: string,
    title: string,
    subtitle: string,
    href: string,
    disabled: boolean
}

export default function GlobalCommandMenu() {
    const [open, setOpen] = useState(false)
    const [value, setValue] = useState('')
    const navigate = useNavigate()




    const level = localStorage.getItem('level') || '0';
    const stockPointType = localStorage.getItem('stockPointType') || '0';
    const stockPointId = localStorage.getItem('stockPointId') || '0';
    const size = localStorage.getItem('pharmacySize') || '0';

    const defaultCommands: InternalCommand[] = []

    if (level === Level.STOCK_POINT.toString() && stockPointType === StockPointType.RECEIVING.toString()) {
        defaultCommands.push({
            title: 'Inventory',
            subtitle: 'Go to Inventory',
            href: '/inventory',
            disabled: false
        })
        defaultCommands.push({
            title: 'Available Inventory',
            subtitle: 'Show Available inventory',
            href: '/inventory/available-inventory',
            disabled: false
        })
        defaultCommands.push({
            title: 'Create Purchase Invoice',
            subtitle: 'Create New Purchase Invoice',
            href: '/inventory/purchase-invoice/create',
            disabled: false
        })
        defaultCommands.push({
            title: 'Create Purchase Order',
            subtitle: 'Create New Purchase Order',
            href: '/inventory/create-purchase-order',
            disabled: false
        })
        defaultCommands.push({
            title: 'Suppliers',
            subtitle: 'Go to Suppliers',
            href: '/suppliers',
            disabled: false
        })
        defaultCommands.push({
            title: 'Reports',
            subtitle: 'Go to Reports',
            href: '/reports',
            disabled: false
        })
        defaultCommands.push({
            title: 'Settings',
            subtitle: 'Pharmacy Settings',
            href: '/settings',
            disabled: false
        })
    } else if (level === Level.STOCK_POINT.toString() && stockPointType !== StockPointType.RECEIVING.toString()) {
        defaultCommands.push({
            title: 'Overview',
            subtitle: 'Go to Overview',
            href: '/overview',
            disabled: false
        })
        defaultCommands.push({
            title: 'Sales',
            subtitle: 'Go to Sales',
            href: '/sales',
            disabled: false
        })
        defaultCommands.push({
            title: 'Patients',
            subtitle: 'Go to Patients',
            href: '/patients',
            disabled: false
        })
        defaultCommands.push({
            title: 'Inventory',
            subtitle: 'Go to Inventory',
            href: '/inventory',
            disabled: false
        })
        defaultCommands.push({
            title: 'Reports',
            subtitle: 'Go to Reports',
            href: '/reports',
            disabled: false
        })
        defaultCommands.push({
            title: 'Settings',
            subtitle: 'Pharmacy Settings',
            href: '/settings',
            disabled: false
        })
    } else if (level === Level.BRANCH.toString()) {

        defaultCommands.push({
            title: 'Dashboard',
            subtitle: 'Branch Dashboard',
            href: '/branch/dashboard',
            disabled: false
        })

        defaultCommands.push({
            title: 'Reports',
            subtitle: 'Go to Reports',
            href: '/branch/reports',
            disabled: false
        })

        defaultCommands.push({
            title: 'Automations',
            subtitle: 'Go to Automations',
            href: '/branch/automations',
            disabled: false
        })

        defaultCommands.push({
            title: 'Purchase Orders',
            subtitle: 'View Purchase Orders',
            href: '/branch/purchase-orders',
            disabled: false
        })

        defaultCommands.push({
            title: 'Purchase Invoices',
            subtitle: 'View Purchase Invoices',
            href: '/branch/purhcase-invoices',
            disabled: false
        })

        defaultCommands.push({
            title: 'Accounts',
            subtitle: 'Go to Accounts',
            href: '/branch/accounts',
            disabled: false
        })

        defaultCommands.push({
            title: 'Inventory',
            subtitle: 'View Inventory',
            href: '/branch/inventory',
            disabled: false
        })

        defaultCommands.push({
            title: 'Settings',
            subtitle: 'Go to Settings',
            href: '/branch/settings',
            disabled: false
        })
        

    }

    const [extraCommands, setExtraCommands] = useState<InternalCommand[]>(defaultCommands)
    const [searchCommands, setSearchCommands] = useState<InternalCommand[]>([])
    const [aiCommands, setAiCommands] = useState<InternalCommand[]>([])
    useEffect(() => {
        const down = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                setValue('')
            }
            if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
                e.preventDefault()
                setOpen((open) => !open)
            }
        }

        const openMenu = () => { setOpen(true) }



        document.addEventListener("keydown", down)
        document.addEventListener("open-command-menu", openMenu)
        return () => {
            document.removeEventListener("open-command-menu", openMenu)
            document.removeEventListener("keydown", down)
        }
    }, [])

    useEffect(() => {
        const finalCommands: InternalCommand[] = []
        if (value.length > 0) {
            // Filter Commands
            const commands = extraCommands.filter((c) => c.title.toLowerCase().includes(value.toLowerCase()))
            finalCommands.push(...commands)
            setExtraCommands(finalCommands)
            if (value.length > 3) {
                const getMeds = async () => {
                    const finalData = await pharmacyClient.searchInventory({
                        query: value,
                        limit: 10,
                        onlyAvailable: true,
                        stockPointId: stockPointId,
                    })
                    const commands = finalData.items.map((c) => ({
                        title: c.tradeName,
                        subtitle: `${c.unit} ${c.unitType} | ${c.isSuggestion ? 'Suggested' : c.availableStock > 0 ? 'In Stock' : 'Out of Stock'}`,
                        href: `/inventory/item/${c.type === ItemType.MEDICAL ? "MEDICAL" : "NON_MEDICAL"}/${c.id}`,
                        disabled: false
                    }))
                    setSearchCommands(commands)
                }
                const getAIPredictions = async () => {
                    const response = await httpClient().post(
                        `${import.meta.env.VITE_AI_API_URL as string}/nlu/predict`,
                        {
                            text: value,
                        }
                    );
                    const finalData = response.data as AICommandPredictionSchema
                    if (finalData.intent !== 'fallback_intent') {
                        const url = intent_url_mapper[finalData.intent]
                        const commands = [{
                            title: finalData.config.display_name,
                            subtitle: `${!finalData.config.requires_start_date && !finalData.config.requires_end_date ? "Open report" : ""} ${finalData.config.requires_start_date ? finalData.entities.start_date ? dayjs(finalData.entities.start_date).format("DD MMM YYYY") : 'Start Date Required' : ''} ${finalData.config.requires_end_date ? " to " : ''} ${finalData.config.requires_end_date ? finalData.entities.end_date ? dayjs(finalData.entities.end_date).format("DD MMM YYYY") : 'End Date Required' : ''}`,
                            href: `${url}?${finalData.config.requires_start_date && !finalData.config.requires_end_date ? `date=${finalData.entities.start_date}` : ''}${finalData.config.requires_start_date && finalData.config.requires_end_date ? `startDate=${finalData.entities.start_date}&endDate=${finalData.entities.end_date}` : ''}`,
                            disabled: finalData.config.requires_start_date && !finalData.entities.start_date || finalData.config.requires_end_date && !finalData.entities.end_date
                        }]
                        setAiCommands(commands)
                    }
                }
                getMeds()
                // getAIPredictions()
            }
        } else {
            setExtraCommands(defaultCommands)
        }
    }, [value])

    return (
        <CommandDialog open={open} onOpenChange={setOpen}>

            <CommandInput placeholder="Type a command or search..." value={value} onValueChange={setValue}>

            </CommandInput>
            <CommandList className='min-h-[70vh]'>
                <CommandEmpty>No Results Found.</CommandEmpty>
                <CommandGroup heading="Actions" className='[&_[cmdk-item]]:p-0'>
                    {extraCommands.map((c, i) => <CommandItemWrapper navigate={navigate} setOpen={setOpen} key={i} title={c.title} subtitle={c.subtitle} href={c.href} disabled={c.disabled}></CommandItemWrapper>)}
                </CommandGroup>
                <CommandGroup heading="Search Results">
                    {searchCommands.map((c, i) => <CommandItemWrapper navigate={navigate} setOpen={setOpen} key={i} title={c.title} subtitle={c.subtitle} href={c.href} disabled={c.disabled}></CommandItemWrapper>)}
                </CommandGroup>
                <CommandGroup heading="Neulink Business Intelligence Results">
                    {aiCommands.map((c, i) => <CommandItemWrapper navigate={navigate} setOpen={setOpen} key={i} title={c.title} subtitle={c.subtitle} href={c.href} disabled={c.disabled}></CommandItemWrapper>)}
                </CommandGroup>
            </CommandList>
        </CommandDialog>
    )
}